import { Copy } from 'lucide-react';
import toast from 'react-hot-toast';

async function copyToClipboard(text) {
  if (text == null || String(text).trim() === '') return false;
  const str = String(text);
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(str);
      return true;
    }
  } catch {
    // fall through to execCommand fallback
  }
  try {
    const ta = document.createElement('textarea');
    ta.value = str;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}

/**
 * Icon button to copy text to the clipboard. Renders nothing when text is empty.
 */
export default function CopyTextButton({
  text,
  label = 'Copy',
  size = 'sm',
  title = 'Copy to clipboard',
  className = '',
}) {
  const str = text == null ? '' : String(text);
  if (!str.trim()) return null;

  const handleClick = async (e) => {
    e.stopPropagation();
    const ok = await copyToClipboard(str);
    if (ok) toast.success('Copied to clipboard');
    else toast.error('Failed to copy');
  };

  const sizeClasses =
    size === 'xs'
      ? 'px-1.5 py-0.5 text-xs'
      : 'px-2 py-1 text-sm';

  const iconClass = size === 'xs' ? 'h-3 w-3' : 'h-4 w-4';

  return (
    <button
      type="button"
      onClick={handleClick}
      title={title}
      className={`no-print inline-flex shrink-0 items-center gap-1 rounded border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 ${sizeClasses} ${className}`}
    >
      <Copy className={iconClass} aria-hidden />
      {label ? <span>{label}</span> : null}
    </button>
  );
}
